import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import _ from 'lodash';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import {
  orgTeamSchema,
  orgTeamListSchema,
} from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/orgTeams/actions';
import { OrgTeamsActionTypes as types } from 'app/ducks/orgTeams/types';

function* getOrgTeamSaga(action): any {
  yield put(sagaActions.getOrgTeamPending());
  const [error, response] = yield (
    yield (yield TeammoApi(yield select()))
  ).dataOrgTeams.show(action.payload);
  if (response) {
    const normalizedResponse = normalize(response, orgTeamSchema);
    yield put(sagaActions.getOrgTeamSuccess(normalizedResponse));
    const pc = normalizedResponse.entities.orgTeams[normalizedResponse.result];
    return pc;
  }
  yield put(
    handleError(
      error,
      sagaActions.getOrgTeamFailed(_.isEmpty(error) ? {} : error.response.data.errors),
    ),
  );
  return null;
}

function* getAllOrgTeamsSaga(action): any {
  yield put(
    sagaActions.getAllOrgTeamsPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.orgTeams.pagination),
    )
    : action.payload.pagination;

  const [error, response] = yield (yield (yield TeammoApi(yield select()))).dataOrgTeams.list(paginationObject);
  if (response) {
    const normalizedResponse = normalize(response, orgTeamListSchema);

    yield put(
      sagaActions.getAllOrgTeamsSuccess(
        normalizedResponse,
        response.meta,
      ),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllOrgTeamsFailed(_.isEmpty(error) ? {} : error.response.data.errors),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* getOrgTeamSagaWatcher(): any {
  yield takeEvery(
    types.GET_ORG_TEAM_REQUESTED,
    getOrgTeamSaga,
  );
}

function* getAllOrgTeamsSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_ORG_TEAMS_REQUESTED,
    getAllOrgTeamsSaga,
  );
}

export default function* root(): any {
  yield all([
    getOrgTeamSagaWatcher(),
    getAllOrgTeamsSagaWatcher(),
  ]);
}
